export default __webpack_public_path__ + "static/media/face_2_41.64ff5090.png";